import React from 'react';
import { 
  LayoutDashboard, 
  Bell, 
  User, 
  FileText, 
  TrendingUp, 
  BellRing, 
  LineChart, 
  UserCog,
  Settings
} from 'lucide-react';
import './Sidebar.css';
import { getTranslation } from '../config/translations';
import { useLanguage } from '../context/LanguageContext';

interface SidebarProps {
  currentPage: string;
  onNavigate: (page: string) => void;
}

const Sidebar: React.FC<SidebarProps> = ({ currentPage, onNavigate }) => {
  const { language } = useLanguage();

  const t = (key: string) => getTranslation(language, key);

  const menuItems = [
    { icon: <LayoutDashboard size={18} />, label: t('dashboard'), page: 'dashboard', key: 'dashboard' },
    { icon: <Bell size={18} />, label: t('notificationsMenu'), page: 'notifications', badge: 8, key: 'notificationsMenu' },
    { icon: <User size={18} />, label: t('coach'), page: 'coach', key: 'coach' },
    { icon: <FileText size={18} />, label: t('documents'), page: 'documents', key: 'documents' },
    { icon: <UserCog size={18} />, label: t('account'), page: 'account', key: 'account' },
    { icon: <TrendingUp size={18} />, label: t('progress'), page: 'progress', key: 'progress' },
    { icon: <BellRing size={18} />, label: t('foodLog'), page: 'foodlog', key: 'foodLog' },
    { icon: <LineChart size={18} />, label: t('charts'), page: 'charts', key: 'charts' },
  ];

  return (
    <aside className="sidebar">
      <nav className="sidebar-nav">
        {menuItems.map((item, index) => (
          <button
            key={index}
            className={`sidebar-item ${currentPage === item.page ? 'active' : ''}`}
            onClick={() => onNavigate(item.page)}
          >
            <span className="sidebar-icon">{item.icon}</span>
            <span className="sidebar-label">{item.label}</span>
            {item.badge && <span className="sidebar-badge">{item.badge}</span>}
          </button>
        ))}
      </nav>
      <div className="sidebar-footer">
        <button
          className={`sidebar-item ${currentPage === 'settings' ? 'active' : ''}`}
          onClick={() => onNavigate('settings')}
        >
          <span className="sidebar-icon"><Settings size={18} /></span>
          <span className="sidebar-label">{t('settings')}</span>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
